import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import get from 'lodash/get';

@Module({ namespaced: true })
export default class Tenants extends VuexModule {
  _tenants: Tenant[] = [];
  _softTenants: any[] = [];
  _selectedTenant?: Tenant = undefined;
  _selectedSoftTenant?: any = undefined;

  get tenants(): Tenant[] {
    return this._tenants;
  }

  get softTenants(): any[] {
    return this._softTenants;
  }

  get selectedTenant(): Tenant | undefined {
    return this._selectedTenant;
  }

  get selectedSoftTenant(): any | undefined {
    return this._selectedSoftTenant;
  }

  get currentTenantName(): String | undefined {
    return get(this.selectedTenant, 'name');
  }

  get currentTenantLongName(): String | undefined {
    return get(this.selectedTenant, 'longName');
  }

  @Mutation
  SET_TENANT_LIST(tenants: Tenant[]) {
    this._tenants = tenants;
  }
  @Mutation
  SET_SOFT_TENANTS(tenants: any[]) {
    this._softTenants = tenants;
  }

  @Mutation
  SET_SELECTED_TENANT(tenant: Tenant) {
    this._selectedTenant = tenant;
  }

  @Mutation
  SET_SELECTED_SOFT_TENANT(tenant: any) {
    this._selectedSoftTenant = tenant;
  }

  @Mutation
  ADD_TENANT(tenant: Tenant) {
    this._tenants.push(tenant);
  }

  @Mutation
  REMOVE_TENANT(tenantId: string) {
    const idx = this._tenants.findIndex((el) => el._id === tenantId);
    this._tenants.splice(idx, 1);
  }

  @Mutation
  SET_AGENCY_SOFT_TENANTS({
    tenantId,
    softTenants,
  }: {
    tenantId: string;
    softTenants: any[];
  }) {
    const idx = this._tenants.findIndex((el) => el._id === tenantId);
    this._tenants[idx].softTenants = softTenants;
  }

  @Action
  async FETCH_TENANT_LIST(kuzzle: any) {
    console.log('ACTION FETCH_TENANT_LIST');

    const tenants: Tenant[] = [];

    try {
      const response = await kuzzle.query({
        controller: 'multi-tenancy/tenant',
        action: 'list',
      });

      if (!response.result.tenants.length) {
        this.context.commit('SET_SELECTED_TENANT', null);
        this.context.commit('SET_TENANT_LIST', []);
        return;
      }

      for (const tenant of response.result.tenants) {
        tenants.push({
          _id: tenant._id,
          group: tenant._source.group,
          index: tenant._source.index,
          name: tenant._source.name,
          longName: get(
            tenant._source,
            'metadata.longName',
            tenant._source.name
          ),
          softTenants: tenant._source.softTenants,
        });
      }

      this.context.commit('SET_SELECTED_TENANT', tenants[0]);
      this.context.commit('SET_TENANT_LIST', tenants);

      for (const agency of tenants) {
        const assetsRes = await kuzzle.query({
          index: agency.index,
          controller: 'device-manager/asset',
          action: 'search',
          body: {
            // query: {
            //   equals: {
            //     type: 'residence',
            //   },
            // },
            sort: {
              reference: 'asc',
            },
          },
          size: 100,
          lang: 'koncorde',
        });

        this.context.commit('SET_AGENCY_SOFT_TENANTS', {
          tenantId: agency._id,
          softTenants: assetsRes.result.hits,
        });
      }

      const assetsRes = await kuzzle.query({
        index: tenants[0].index,
        controller: 'device-manager/asset',
        action: 'search',
        body: {
          // query: {
          //   equals: {
          //     type: 'residence',
          //   },
          // },
          sort: {
            reference: 'asc',
          },
        },
        size: 100,
        lang: 'koncorde',
      });

      this.context.commit('SET_SOFT_TENANTS', assetsRes.result.hits);
      this.context.commit('SET_SELECTED_SOFT_TENANT', assetsRes.result.hits[0]);
    } catch (error) {
      throw error;
    }

    this.context.commit('SET_TENANT_LIST', tenants);
  }

  @Action
  async FETCH_USER_TENANTS(kuzzle: any) {
    console.log('ACTION FETCH_USER_TENANTS');

    const tenants: Tenant[] = [];

    try {
      const currentUser = await kuzzle.auth.getCurrentUser();

      for (const tenant of currentUser.content.tenants) {
        tenants.push({
          _id: tenant.index,
          group: tenant.group,
          index: tenant.index,
          name: tenant.name,
          longName: tenant.longName || tenant.name,
          softTenants: tenant.softTenants,
        });
      }

      this.context.commit('SET_TENANT_LIST', tenants);

      for (const agency of tenants) {
        const assetsRes = await kuzzle.query({
          index: agency.index,
          controller: 'device-manager/asset',
          action: 'search',
          body: {
            // query: {
            //   equals: {
            //     type: 'residence',
            //   },
            // },
            sort: {
              reference: 'asc',
            },
          },
          size: 100,
          lang: 'koncorde',
        });

        console.log('fetched residences for current user');

        this.context.commit('SET_AGENCY_SOFT_TENANTS', {
          tenantId: agency._id,
          softTenants: assetsRes.result.hits,
        });
      }

      this.context.commit('SET_SELECTED_TENANT', tenants[0]);
      this.context.commit('SET_SOFT_TENANTS', tenants[0].softTenants);
      this.context.commit(
        'SET_SELECTED_SOFT_TENANT',
        tenants[0].softTenants[0]
      );
    } catch (error) {
      throw error;
    }

    // this.context.commit('SET_TENANT_LIST', tenants);
  }
}

interface Tenant {
  _id: string;
  group: string;
  index: string;
  name: string;
  longName?: string;
  softTenants: string[];
}
